import { useTranslate } from 'react-admin';
import { billOfMaterialsStatusChoices } from '@/components/global/options/selectOptions.jsx';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import { Box } from '@mui/material';

export const StatusField = ({ record }) => {
    const translate = useTranslate();
    const status = billOfMaterialsStatusChoices(translate).find(s => s.id === record.status);
    const Icon = ({ status }) => {
        switch (status) {
            case 'archived':
                return <DisactiveIcon />;
            case 'inUse':
            default:
                return <ActiveIcon />;
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Icon status={record.status} />
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginLeft: '8px' }}>{status.name}</div>
        </Box>
    );
};
